import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const UpdateTestCostModal = ({ isOpen, onRequestClose, testId }) => {
  const navigate = useNavigate();
  const [cost, setCost] = useState("");
  const [loading, setLoading] = useState(false);
  const [existingCost, setExistingCost] = useState(null);

  useEffect(() => {
    if (testId && isOpen) {
      fetchExistingCost();
    }
  }, [testId, isOpen]);

  const fetchExistingCost = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      const response = await axios.get(`/api/labTestCost/getUpdatedCost/testId=${testId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setExistingCost(response.data);
      setCost(response.data?.cost || "");
    } catch {
      toast.error("Failed to fetch test cost.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!cost || parseFloat(cost) <= 0) {
      toast.error("Please enter a valid cost.");
      return;
    }

    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    try {
      const requestBody = {
        testId: testId,
        cost: parseFloat(cost)
      };

      await axios.post(`/api/labTestCost/create`, requestBody, {
        headers: { Authorization: `Bearer ${token}` },
      });
      
      toast.success("Test cost updated successfully");
      handleClose();
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const handleClose = () => {
    setCost("");
    setExistingCost(null);
    onRequestClose();
  };

  return (
    <Modal show={isOpen} onHide={handleClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">sell</i>
          Update Diagnostic Test Cost
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          {existingCost && (
            <div className="mb-3 p-3 rounded-3 bg-light border">
              <span className="text-muted small d-block">Current Test Cost:</span>
              <h5 className="fw-bold m-0" style={{ color: "#2f3a88" }}>₹ {existingCost.cost}</h5>
            </div>
          )}

          <div className="mb-4">
            <label htmlFor="cost" className="form-label small fw-semibold">
              New Cost (₹) <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="cost"
              type="number"
              step="0.01"
              min="0"
              placeholder="Enter new test cost..."
              value={cost}
              onChange={(e) => setCost(e.target.value)}
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>price_change</i>
              Update Cost
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateTestCostModal;